<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct">Contents</p>
<p class="tocpt"><a href="#/APerfectSecreteBook3">Acknowledgments</a></p>
<p class="tocpt"><a href="#/APerfectSecreteBook4">Dedication</a></p>
<p class="tocpt"><a href="#/APerfectSecreteBook5">Glossary</a></p>
<p class="tocpt"><a href="#/APerfectSecreteBook7">Prologue</a></p>
<p class="tocpt"><a href="#/APerfectSecreteBook8">Chapter One</a></p>
<p class="tocpt"><span href="#/APerfectSecreteBook9" title="Link target outside of Sample">Chapter Two</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook10" title="Link target outside of Sample">Chapter Three</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook11" title="Link target outside of Sample">Chapter Four</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook12" title="Link target outside of Sample">Chapter Five</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook13" title="Link target outside of Sample">Chapter Six</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook14" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook15" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook16" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook17" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook18" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook19" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook20" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook21" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook22" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook23" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook24" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook25" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook26" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook27" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook28" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook29" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook30" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook31" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook32" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook33" title="Link target outside of Sample">Chapter Twenty-Six</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook34" title="Link target outside of Sample">Reading Group Guide</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook35" title="Link target outside of Sample">Amish Recipes</span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook36" title="Link target outside of Sample">An Excerpt from <em class="i">Sarah’s Garden</em></span></p>
<p class="tocpt"><span href="#/APerfectSecreteBook41" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// APerfectSecreteBook2.vue?332f836c